"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = exports.TIMEOUT = exports.dataHooks = void 0;
var dataHooks = {
  tooltipText: 'tooltip-text'
};
exports.dataHooks = dataHooks;
var TIMEOUT = {
  enter: 100,
  exit: 150
};
exports.TIMEOUT = TIMEOUT;
var SIZES = {
  small: 'small',
  medium: 'medium'
};
exports.SIZES = SIZES;